// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DateFieldCalendar__container-e38fd0 {
  padding: 24px 24px 0px 24px;
}

.DateFieldCalendar__footer-aac9e9 * + * {
  margin-inline-start: 12px;
}

.DateFieldCalendar__popup-container-ef79c6.DateFieldCalendar__popup-f28fd5 {
  flex: none;
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/form/DateField/DateFieldCalendar/DateFieldCalendar.styles.m.css"],"names":[],"mappings":"AAAA;EACE,2BAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,UAAA;AACF","sourcesContent":[".container {\n  padding: 24px 24px 0px 24px;\n}\n\n.footer * + * {\n  margin-inline-start: 12px;\n}\n\n.popup-container.popup {\n  flex: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DateFieldCalendar__container-e38fd0`,
	"footer": `DateFieldCalendar__footer-aac9e9`,
	"popup-container": `DateFieldCalendar__popup-container-ef79c6`,
	"popupContainer": `DateFieldCalendar__popup-container-ef79c6`,
	"popup": `DateFieldCalendar__popup-f28fd5`
};
module.exports = ___CSS_LOADER_EXPORT___;
